import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterARByAC'
})
export class FilterARByACPipe implements PipeTransform {
    transform(items: Array<any>, idAC: number): Array<any> {
        if (idAC > 0) {
            return items.filter(item => item.entidadesPai ? item.entidadesPai.some(x => x.idEntidade === idAC) : false).filter(x => x.Acoes.length > 0);
        } else {
            return items.filter(x => x.Acoes.length > 0);
        }
    }
}
